const $header = $('.header'),
    $search = $('.search'),
    $navigation = $('.navigation'),
    $subnav = $navigation.find('.navigation-main');

let menuAimActive = false;

function checkMenuAIm() {
    const isMobile = $('.c-var .xs-is-visible').is(':visible') || $('.c-var .cxs-is-visible').is(':visible');

    if (!menuAimActive && !isMobile) {
        $subnav.menuAim({
            activate: activateSubmenu,
            deactivate: deactivateSubmenu,
            rowSelector: ".navigation-main__item:not(.is-sales)"
        });

        menuAimActive = true;
    }
    else if (menuAimActive && isMobile) {
        $subnav.menuAim('destroy');

        menuAimActive = false;
    }
}

function setSubmenuHeight() {
    const submenuHeight = $('.navigation-sub.is-active').outerHeight();

    $('.navigation__wrapper').css('min-height', submenuHeight + 'px');
}

function activateSubmenu(row) {
    const $this = $(row);

    $navigation.find('.is-active').removeClass('is-active');

    $this.find('.c-link').addClass('is-active');
    $this.find('.navigation-sub').addClass('is-active');

    setSubmenuHeight();
}

function deactivateSubmenu(row) {
    const $this = $(row);

    $navigation.find('.is-active').removeClass('is-active');
    $('.navigation__wrapper').attr('style', '');
}

$(function() {
    checkMenuAIm();

    $(window).on('resize', function() {
        checkMenuAIm();
    });

    $('.header').on('click', '.js-minicart-trigger', function(event) {
        const $minicart = $('.minicart');

        if ($('.c-var .cxs-is-visible').is(':hidden')) {
            event.preventDefault();

            if ($header.hasClass('has-active-minicart')) {
                $header.removeClass('has-active-minicart');
                $minicart.hide();
                hideOverlay();
            } else {
                $header.addClass('has-active-minicart');
                $minicart.show();
                showOverlay();
            }
        }
    });

    $('.js-nav-trigger').on('click', function(event) {
        event.preventDefault();
        if ($header.hasClass('has-active-nav')) {
            $navigation.hide();
            $header.removeClass('has-active-nav');
            hideOverlay();
        } else {
            $navigation.show();
            $header.addClass('has-active-nav');
            showOverlay();
        }
    });

    $('.js-search-trigger').on('click', function(event) {
        event.preventDefault();
        if ($header.hasClass('has-active-search')) {
            $search.hide();
            $header.removeClass('has-active-search');
            hideOverlay();
        } else {
            $search.show();
            $search.find('.c-form__input').trigger('focus');
            $header.addClass('has-active-search');
            showOverlay();
        }
    });

    $('.navigation-main__item > a').on('click', function(event) {
        const $this = $(this).parent();

        if ($this.hasClass('is-sales')) {
            return true;
        }

        event.preventDefault();

        if (!menuAimActive) {
            $('.navigation-main .is-active').each(function() {
                $(this).removeClass('is-active');
            });

            $this
                .addClass('is-active')
                .find('.navigation-sub').addClass('is-active');
        }
    });

    $('body').on('click', function(event) {
        const $minicart = $('.minicart'),
            notMinicart = !$(event.target).closest('.minicart').length && !$(event.target).closest('.js-minicart-trigger').length,
            notNavigation = !$(event.target).closest('.navigation').length && !$(event.target).closest('.js-nav-trigger').length,
            notSearch = !$(event.target).closest('.search').length && !$(event.target).closest('.js-search-trigger').length,
            notPrettyAlert = !$(event.target).closest('.sweet-alert').length,
            notDropdown = !$(event.target).closest('.js-dropdown').length;

        if (notMinicart && notPrettyAlert) {
            if ($header.hasClass('has-active-minicart')) {
                $minicart.hide();
                $header.removeClass('has-active-minicart');
            }

            if (notNavigation && notSearch && notPrettyAlert && notDropdown) {
                hideOverlay();
            }
        }

        if (notNavigation) {
            if ($header.hasClass('has-active-nav')) {
                $navigation.hide();
                $('body').css('overflow', 'inherit');
                $header.removeClass('has-active-nav');
            }

            if (notMinicart && notSearch && notPrettyAlert && notDropdown) {
                hideOverlay();
            }
        }

        if (notSearch) {
            if ($header.hasClass('has-active-search')) {
                $search.hide();
                $header.removeClass('has-active-search');
            }

            if (notMinicart && notNavigation && notPrettyAlert && notDropdown) {
                hideOverlay();
            }
        }

        if (notDropdown) {
            $('.js-dropdown').removeClass('is-active');

            if (notMinicart && notNavigation && notSearch && notPrettyAlert) {
                hideOverlay();
            }
        }
    });

    if ($('.header__breadcrumb').length > 0) {
        $('.header__breadcrumb .rcrumbs').rcrumbs({
            nbFixedCrumbs: 1,
            nbUncollapsableCrumbs: 1,
            animation: {
                activated: false
            }
        });
    }
});
